import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import fetcher from '../services/fetcher'
import { isPrerendering } from '../services/prerender';

const nextjsIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11' stroke='%23000' stroke-width='2'/%3E%3Cpath d='M8 16V8l8 8V8' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E";
const woocommerceIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect x='2' y='5' width='20' height='14' rx='3' stroke='%236a4a00' stroke-width='2'/%3E%3Cpath d='M8 10.5c.4-.9 1.1-1.5 2-1.5 1 0 1.6.5 2 1.6.4-1.1 1.1-1.6 2.1-1.6 1.4 0 2.4 1.3 2.4 3.1 0 2.6-1.8 4.4-4.5 4.4s-4.5-1.8-4.5-4.4c0-.6.2-1.2.5-1.6Z' fill='%236a4a00'/%3E%3C/svg%3E";
const zapierIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M12 3v18M3 12h18M5.6 5.6l12.8 12.8M18.4 5.6 5.6 18.4' stroke='%23ff4f00' stroke-width='2' stroke-linecap='round'/%3E%3Ccircle cx='12' cy='12' r='2.2' fill='%23000'/%3E%3C/svg%3E";
const n8nIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M7 7h10M7 17h10M7 7l10 10M7 17l10-10' stroke='%23ea4b71' stroke-width='2' stroke-linecap='round'/%3E%3Ccircle cx='5' cy='7' r='2.2' fill='%23ea4b71'/%3E%3Ccircle cx='19' cy='7' r='2.2' fill='%23ea4b71'/%3E%3Ccircle cx='5' cy='17' r='2.2' fill='%23ea4b71'/%3E%3Ccircle cx='19' cy='17' r='2.2' fill='%23ea4b71'/%3E%3C/svg%3E";
const iftttIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect x='3' y='5' width='3' height='14' rx='1.2' fill='%23000'/%3E%3Crect x='8' y='5' width='3' height='14' rx='1.2' fill='%23000'/%3E%3Crect x='13' y='5' width='3' height='14' rx='1.2' fill='%23000'/%3E%3Crect x='18' y='5' width='3' height='14' rx='1.2' fill='%23000'/%3E%3Cpath d='M8 9h8M8 15h8' stroke='%2300a7ff' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E";
const mcpIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Crect x='3' y='4' width='18' height='16' rx='3' stroke='%238a6a14' stroke-width='2'/%3E%3Cpath d='M7 9h10M7 15h10M9 12h6' stroke='%23000' stroke-width='2' stroke-linecap='round'/%3E%3Ccircle cx='6' cy='6' r='1.3' fill='%238a6a14'/%3E%3Ccircle cx='18' cy='18' r='1.3' fill='%238a6a14'/%3E%3C/svg%3E";

function BlogPosts(props){
  const [articles, setArticles] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { items, onArticlesLoaded, random } = props;

  useEffect(() => {
    async function getBlogPosts(){
      setIsLoading(true)
      const data = await fetcher.getBlogPosts()
      if (data){
        const visibleArticles = data.filter(article => article.show);
        const selectedArticles = (random && !isPrerendering()
          ? [...visibleArticles].sort(() => Math.random() - 0.5)
          : visibleArticles
        ).slice(0, items);
        setArticles(selectedArticles);
        if (onArticlesLoaded) onArticlesLoaded(selectedArticles);
        setIsLoading(false)
      }
    }

    getBlogPosts()
  }, [items, onArticlesLoaded, random]);

  if (articles && !isLoading){
    const articleIcons = {
      wordpress: 'https://img.icons8.com/ios-filled/50/000000/wordpress.png',
      shopify: 'https://img.icons8.com/ios-filled/50/000000/shopify.png',
      excel: 'https://img.icons8.com/ios-filled/50/000000/microsoft-excel-2019.png',
      joomla: 'https://img.icons8.com/ios-filled/50/000000/joomla.png',
      drupal: 'https://img.icons8.com/ios-filled/50/000000/drupal.png',
      nextjs: nextjsIcon,
      'google-sheets': 'https://img.icons8.com/ios-filled/50/000000/google-sheets.png',
      'node-express': 'https://img.icons8.com/windows/32/000000/node-js.png',
      fastapi: 'https://img.icons8.com/ios-filled/50/000000/python.png',
      laravel: 'https://img.icons8.com/ios-filled/50/000000/laravel.png',
      woocommerce: woocommerceIcon,
      magento: 'https://img.icons8.com/ios-filled/50/000000/magento.png',
      'react-native': 'https://img.icons8.com/ios-filled/50/000000/react-native.png',
      zapier: zapierIcon,
      n8n: n8nIcon,
      airtable: 'https://img.icons8.com/ios-filled/50/000000/airtable.png',
      webflow: 'https://img.icons8.com/ios-filled/50/000000/webflow.png',
      ifttt: iftttIcon,
      mcp: mcpIcon,
      'power-bi': 'https://img.icons8.com/ios-filled/50/000000/power-bi.png'
    };

    const renderArticleLink = (article, children, className = '') => {
      const href = `/blog/${article.slug}`;

      if (props.openInNewTab) {
        return (
          <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
            {children}
          </a>
        );
      }

      return (
        <Link to={href} className={className}>
          {children}
        </Link>
      );
    };

    const articlesList = articles.map((article, index) => (
      <div key={article.slug || index} className="col-lg-4 col-md-6 my-2" data-article-slug={article.slug}>
        <div className="landing-info-card blog-post-card h-100">
          <div className="blog-post-card-header">
            <div className="blog-post-card-icon-wrap">
              <img
                className="blog-post-card-icon"
                src={articleIcons[article.iconKey]}
                alt={`${article.label || article.slug} integration icon`}
              />
            </div>
            <div className="blog-post-card-kicker text-muted">{article.label || article.slug}</div>
          </div>
          <h3 className="blog-post-card-title">
            {renderArticleLink(article, article.title)}
          </h3>
          <p className="blog-post-card-subtitle text-muted mb-0">{article.subtitle}</p>
          <div className="blog-post-card-link">
            {renderArticleLink(article, 'Read article →')}
          </div>
        </div>
      </div>
    ));
    
    return (
      <div className={`row landing-card-grid ${props.embedded ? 'blog-posts-embedded' : 'mt-3 mb-3'}`} data-visible-article-count={articles.length}>
        <div className="col-12">
          <div className="row">
            {articlesList}
          </div>
        </div>
      </div>
    );
  } else {
    return (  
    <div className="spinner my-4">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>);
  }
};

BlogPosts.defaultProps = {
  random: false,
  items: 3,
  openInNewTab: false,
  embedded: false
};

export default BlogPosts;
